import React from "react"
import clsx from "clsx"
import { useSelector } from "react-redux"
import { FaCheckCircle, FaPhone, FaTimesCircle } from "react-icons/fa"
import { useTranslation } from "react-i18next"

import { haveAuth } from "utils"
import TnSnapbox from "./TnSnapbox"
import TnSmsBalance from "./TnSmsBalance"
import TnMyWallet from "./TnMyWallet"
import TnNotificationCenter from "./TnNotificationCenter"
import TnSidebarButton from "./TnSidebarButton"
import TnSidebarLanguages from "./TnSidebarLanguages"
import classes from "./index.module.scss"

const TopNavigation = props => {
  const {
    openSidebar,
    setOpenSidebar,
  } = props

  const [t] = useTranslation()

  const systemIsActivated =
    useSelector(state => state.systemSettings.systemIsActivated)

  const isDeactivationWarningSet =
    useSelector(state =>
      state.contractDeactivationStatus.isDeactivationWarningSet
    )

  return (
    <div
      className={
        clsx(classes["navbar"],
          window.innerWidth >= 1140 &&
          openSidebar &&
          classes["reduce-width"]
        )
      }
    >
      <div className={classes["row"]}>
        <TnSidebarButton
          openSidebar={openSidebar}
          setOpenSidebar={setOpenSidebar}
        />

        <TnSidebarLanguages />
      </div>

      {systemIsActivated
        ?
        <div className={classes["activated"]}>
          {t("سایت_فعال_است")}{" "}
          <FaCheckCircle />
        </div>
        :
        isDeactivationWarningSet
          ?
          <div className={classes["not-activated"]}>
            {t("سایت_به_دلیل_عدم_پرداخت_بدهی_فعال_نیست")}{" "}
            <FaTimesCircle />
            <br />
            {t("تماس_با_پشتیبانی")}:{" "}
            <a className={classes["tel"]} href="tel:02191094093">
              02191094093{" "}
              <FaPhone />
            </a>
          </div>
          :
          <div className={classes["not-activated"]}>
            {t("سایت_فعال_نیست")}{" "}
            <FaTimesCircle />
          </div>
      }

      <div className={classes["actions"]}>
        <TnNotificationCenter />

        {haveAuth(["viewSnappboxWallet"]) && <TnSnapbox />}

        <TnSmsBalance />

        <TnMyWallet />
      </div>
    </div>
  )
}

export default TopNavigation
